<template>
  <BatchDetailsReport v-if="initialData" v-bind="initialData" />
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { setVueState } from "@/lib/vueStateBridge";

import { Filter } from "@/components/DatatableV3.vue";
import BatchDetailsReport from "@/Reports/BatchDetailsReport.vue";

const initialData = ref<{
  id: string;
  source: string;
  summary: {
    id: number;
    name: string;
    invoicesTotal: string;
    paymentsTotal: string;
    completedItemCount: number;
    processingItemCount: number;
    failedItemCount: number;
  };
  filters: Filter[];
} | null>(null);

onMounted(async () => {
  // Load initial page data and send to component as props
  const res = await fetch(`${window.location.pathname}/initial_page_data`, {
    method: "GET"
  });
  initialData.value = await res.json();

  if (initialData.value) {
    setVueState(`batches[${initialData.value.id}]`, initialData.value.summary);
  }
});
</script>

<style scoped></style>
